import { useSelector } from 'src/store/store';
import PostImage from 'src/modules/community/singlePost/components/postImage';
import PostAuthor from 'src/modules/community/singlePost/components/postAuthor';
import GetElement from 'src/components/getElement';
import PrivatePostMessage from 'src/modules/community/singlePost/components/privatePostMessage';
import i18n from 'src/utils/translate';

export default function Post() {
  const post = useSelector(({ pages }) => pages.singlePost.post);
  const { currentCommunity, currentUser } = useSelector(({ context }) => context);

  const isPrivate = post.isPrivate && !currentUser?.isCommunityMemberOrHUStaff;

  if (isPrivate) {
    return (
      <PrivatePostMessage>
        <p>{i18n.t('You need to be a member of this community to see this post.')}</p>
      </PrivatePostMessage>
    );
  }

  return (
    <>
      <PostImage
        communityId={currentCommunity.communityId}
        imageDescription={post.imageDescription}
        imagePreview={post.imagePreview}
        imageUrl={post.imageUrl}
        priority={true}
      />
      <div className="post-body" data-testid="post-body">
        <GetElement enrichedContent={post?.enriched?.body} showVideoPopout={true} />
      </div>
      <PostAuthor />
    </>
  );
}
